import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import actions from "./actions";
import { getEmployeesApi } from "../../services/employees.service"
import {ReducerType} from "../reducer.type";
import { AxiosResponse } from 'axios';
import { ClientWorkspace } from '../client/client.type';
import logError from "../../utils/logError";

const getWorkspace = (state: ReducerType) => state.client.owner.workspace;

export function* GET_EMPLOYEES(action:{payload:string, type:string}) {
    try {
        const workspace: ClientWorkspace = yield select(getWorkspace);
        const response:AxiosResponse<any> = yield call(getEmployeesApi, workspace.uuid, action.payload);
        if (response.data) {
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/employees/sagas/GET_EMPLOYEES", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_EMPLOYEES),
    ])
}